import { defineGtfsTable } from '../../define-table.ts';

export const serviceAlertInformedEntities = defineGtfsTable({
  file: null,
  table: 'service_alert_informed_entities',
  presence: 'optional',
  primaryKey: [
    'alert_id',
    'agency_id',
    'stop_id',
    'route_id',
    'route_type',
    'trip_id',
    'trip_route_id',
    'trip_direction_id',
    'trip_start_time',
    'trip_start_date',
    'trip_schedule_relationship',
    'trip_modified_trip_modifications_id',
    'trip_modified_trip_affected_trip_id',
    'trip_modified_trip_start_time',
    'trip_modified_trip_start_date',
    'direction_id',
  ],
  fields: {
    alert_id: {
      kind: 'id',
      presence: 'required',
      sourcePath: 'parent.id',
      applyFeedPrefix: true,
    },
    agency_id: {
      kind: 'id',
      references: [{ file: 'agency.txt', field: 'agency_id' }],
      sourcePath: 'agencyId',
      applyFeedPrefix: true,
    },
    stop_id: {
      kind: 'id',
      references: [{ file: 'stops.txt', field: 'stop_id' }],
      sourcePath: 'stopId',
      applyFeedPrefix: true,
    },
    route_id: {
      kind: 'id',
      references: [{ file: 'routes.txt', field: 'route_id' }],
      sourcePath: 'routeId',
      applyFeedPrefix: true,
    },
    route_type: { kind: 'integer', minimum: 0, sourcePath: 'routeType' },
    trip_id: {
      kind: 'id',
      references: [{ file: 'trips.txt', field: 'trip_id' }],
      sourcePath: 'trip.tripId',
      applyFeedPrefix: true,
    },
    trip_route_id: {
      kind: 'id',
      sourcePath: 'trip.routeId',
      applyFeedPrefix: true,
    },
    trip_direction_id: {
      kind: 'integer',
      minimum: 0,
      maximum: 1,
      sourcePath: 'trip.directionId',
    },
    trip_start_time: { kind: 'text', sourcePath: 'trip.startTime' },
    trip_start_date: { kind: 'text', sourcePath: 'trip.startDate' },
    trip_schedule_relationship: {
      kind: 'enumeration',
      values: [
        'SCHEDULED',
        'ADDED',
        'UNSCHEDULED',
        'CANCELED',
        'REPLACEMENT',
        'DUPLICATED',
        'DELETED',
        'NEW',
      ],
      sourcePath: 'trip.scheduleRelationship',
    },
    trip_modified_trip_modifications_id: {
      kind: 'id',
      sourcePath: 'trip.modifiedTrip.modificationsId',
      applyFeedPrefix: true,
    },
    trip_modified_trip_affected_trip_id: {
      kind: 'id',
      sourcePath: 'trip.modifiedTrip.affectedTripId',
      applyFeedPrefix: true,
    },
    trip_modified_trip_start_time: {
      kind: 'text',
      sourcePath: 'trip.modifiedTrip.startTime',
    },
    trip_modified_trip_start_date: {
      kind: 'text',
      sourcePath: 'trip.modifiedTrip.startDate',
    },
    direction_id: {
      kind: 'integer',
      minimum: 0,
      maximum: 1,
      sourcePath: 'directionId',
    },
    created_timestamp: { kind: 'integer', presence: 'required' },
    expiration_timestamp: { kind: 'integer', presence: 'required' },
  },
  namespace: 'gtfs-realtime',
});
